"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletLinkUI = void 0;

var WalletLinkUI = /*#__PURE__*/function () {
  function WalletLinkUI(_) {
    _classCallCheck(this, WalletLinkUI);
  }
  /**
   * We want to disable showing the qr code for in-page walletlink if the dapp hasn't provided a json rpc url
   */


  _createClass(WalletLinkUI, [{
    key: "setConnectDisabled",
    value: function setConnectDisabled(_) {}
  }]);

  return WalletLinkUI;
}();

exports.WalletLinkUI = WalletLinkUI;